'use client';

import { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'success' | 'warning' | 'danger' | 'info' | 'purple' | 'default';
  size?: 'sm' | 'md';
}

const variants = {
  success: 'bg-gradient-to-r from-emerald-50 to-teal-50 text-emerald-700 ring-1 ring-emerald-500/20',
  warning: 'bg-gradient-to-r from-amber-50 to-orange-50 text-amber-700 ring-1 ring-amber-500/20',
  danger: 'bg-gradient-to-r from-red-50 to-rose-50 text-red-700 ring-1 ring-red-500/20',
  info: 'bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-700 ring-1 ring-blue-500/20',
  purple: 'bg-gradient-to-r from-purple-50 to-fuchsia-50 text-purple-700 ring-1 ring-purple-500/20',
  default: 'bg-gradient-to-r from-gray-50 to-slate-50 text-gray-700 ring-1 ring-gray-500/20',
};

const sizes = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-xs',
};

export function Badge({ children, variant = 'default', size = 'md' }: BadgeProps) {
  return (
    <span className={`inline-flex items-center font-medium rounded-full ${variants[variant]} ${sizes[size]}`}>
      {children}
    </span>
  );
}
